import {useContext} from 'react';

import {Grid} from '@mui/material';

import {QuestionCards} from '../QuestionCards';

import {AppendixHeader} from './AppendixHeader';
import {getAppendixPageQuestions} from './appendixPageConfig';
import {CultureAnalysisPdfContext} from '../../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';

const QUESTIONS_PER_PAGE = 4;

interface Props {
  pillarKey: string;
  pageTitle: string;
  startIndex?: number;
  endIndex?: number;
  pagePart?: 1 | 2;
}

const getPageSection = (totalQuestions: number, pagePart?: 1 | 2) => {
  if (!pagePart || totalQuestions <= QUESTIONS_PER_PAGE) {
    return undefined;
  }

  return pagePart === 1 ? '1/2' : '2/2';
};

export const CulturePillarAppendixPage = ({
  pillarKey,
  pageTitle,
  startIndex = 0,
  endIndex,
  pagePart,
}: Props) => {
  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const {pillarData, allQuestions, pillarQuestions} = getAppendixPageQuestions(data.cultureHouse, {
    pillarKey,
    pageTitle,
    startIndex,
    endIndex,
    pagePart,
  });

  if (!pillarData?.surveyResults || pillarQuestions.length === 0) {
    return null;
  }

  return (
    <>
      <AppendixHeader
        pageTitle={pageTitle}
        totalOverlap={pillarData.surveyResults.totalOverlap}
        pageSection={getPageSection(allQuestions.length, pagePart)}
      />
      <Grid container px={5}>
        <QuestionCards questions={pillarQuestions} hideOverlap />
      </Grid>
    </>
  );
};
